export const GROUPE_MUTUEL_NAME = 'Groupe Mutuel';

export const GROUPE_MUTUEL_BASE_PRODUCT_CODES = {
  PRIMACARE: 'RF',
  OPTIMED: 'RS',
  SANATEL: 'RT',
  STANDARD: 'AH',
};
